/*eslint-disable */
let BaseURL = process.env.VUE_APP_API_BASE_URL;
let root = {
quizBannerLink: {
  "link": BaseURL + "api/quizzes/public/quiz-banner/"
},
orgLeaderListLink: {
  "link": BaseURL + "api/quizzes/user/organization-leaderboard/"
},
//quiz winners List
quizWinnerLink: {
  "link": BaseURL + "api/quizzes/user/quiz/"
},
//quiz list URl
quizListUrlLink: {
"link": BaseURL + "api/quizzes/user/quiz/"
},
quizDetailLink: {
"link": BaseURL + "api/quizzes/user/quiz/"
},
contestQuizDetailLink: {
"link": BaseURL + "api/quizzes/user/quiz_detail/"
},
quizCreateAnswerLink: {
"link": BaseURL + "api/quizzes/user/useranswer/"
},
quizHistoryLink: {
"link": BaseURL + "api/quizzes/user/user-quiz-history"
},
notesListingLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
notesListLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
notesCreateLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
notesDetailsLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
notesUpdateLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
notesDeleteLink: {
"link": BaseURL + "api/usernotes/usernote/"
},
// subscription plan price
signupPlan: {
"link": BaseURL + "api/payment/public/subscription-plan/"
},

// Courses List
latestCourses: {
"link": BaseURL + "api/courses/user/course/"
},

// Add to my course list
enrollCourses: {
"link": BaseURL + "api/courses/user/my-course/"
},

// My course list
enrolledCoursesList: {
"link": BaseURL + "api/courses/user/my-course/"
},

// Single Course List
enrolledSingleCourse: {
"link": BaseURL + "api/courses/user/course/"
},

// Remove course from my list
removeEnrolledCourse: {
"link": BaseURL + "api/courses/user/my-course/"
},

// course by category

courseByCategory: {
"link": BaseURL + "api/courses/user/category/"
},

// Get user category list

getCourseCatgoryUrl: {
"link": BaseURL + "api/courses/user/category/"
},

// Register
signUp: {
"link": BaseURL + "api/account/signup/"
},

// Refresh Token
refreshToken: {
link: BaseURL + "api/account/token/refresh/"
},

// checkLoginType
checkLoginType: {
"link": BaseURL + "api/account/otp-email/generate/"
},

//Login with OTP
loginWithOtp: {
"link": BaseURL + "api/account/otp-email/login/"
},

// Subscriber Login
signupSubscriberLogin: {
"link": BaseURL + "api/account/subscriber/login/"
},

// Profile
userProfile: {
"link": BaseURL + "api/account/user/"
},

// Useravtar

userAvatar: {
"link": BaseURL + "api/account/user/avatar/"
},

// Update Profile
updateUserProfile: {
"link": BaseURL + "api/account/user/"
},

// Public Course Category
publicCourseCategory: {
"link": BaseURL + "api/courses/public/category/"
},

// Public Course Single
publicCourseRead: {
"link": BaseURL + "api/courses/public/courses/"
},

// Assignments

getAssignmentList: {
"link": BaseURL + "api/assignments/user/assignment/solution/"
},

// Get Single Assignment

getSingleAssignmentlink: {
"link": BaseURL + "api/assignments/user/assignment/"
},

// Upload comment of assignment solution

uploadCommentAssignmentSolutionLink: {
"link": BaseURL + "api/assignments/user/assignment/solution/"
},

// Upload comment of assignment solution

uploadFileAssignmentSolutionLink: {
"link": BaseURL + "api/assignments/user/assignment/solution/file/"
},

// Update user password

updatePasswordLink: {
"link": BaseURL + "api/account/change-password/"
},


// User Verified

userVerfiedLink: {
"link": BaseURL + "api/account/verify/"
},

// FOrgot Password

forgotPwLink: {
"link": BaseURL + "api/account/reset-password/"
},

// PayPal Payment
paypalOrderUrlLink: {
"link": BaseURL + "api/payment/user/order/paypal/"
},
// Get Paypal Payment DetaILS
getpaypalSubscriptionUrlLink: {
"link": BaseURL + "api/payment/user/subscription/"
},
// Get Paypal Payment Plans DetaLS
getpaypalSubscriptionPlansUrlLink: {
"link": BaseURL + "api/payment/user/subscription/plans/"
},
// Paypal Payment Confirmation
paypalPaymentConfirmLink: {
"link": BaseURL + "api/payment/user/order/paypal/confirm/"
},
// Payment History Details
paymentHistoryLink: {
"link": BaseURL + "api/payment/user/order/history/"
},
// Media List
mediaListLink: {
"link": BaseURL + "api/oddnary/media/"
},

// Pro INfo Index Update
proInfoByIndexLink: {
"link": BaseURL + "api/account/user/professional-info-index-update/"
},
// Cv File Update
cvFileUpdateLink: {
"link": BaseURL + "api/account/user/cv-update"
},
// Notes Multiple Files Upload Link
noteFilesUploadLink: {
"link": BaseURL + "api/usernotes/usernotesfile/"
},
// Public Courses PDF Link
pubCoursesPdfLink: {
"link": BaseURL + "api/courses/public/course-content-list-pdf/"
},
// Public Quiz Question Link
pubQuizQuestionLink: {
"link": BaseURL + "api/quizzes/public/get-question/"
},
// Public Quiz Result Link
pubQuizResultLink: {
"link": BaseURL + "api/quizzes/public/question-submit/"
},
// Quiz Contest Link
quizContestListLink: {
"link": BaseURL + "api/quizzes/user/contest/"
},
courseSectionFileReadUrl:{
    "link": BaseURL + "api/courses/user/file/"
},
// Help Page Url
helpPageUrl:{
    "link":BaseURL + "api/account/help_page_mail/"
},
// Contest Point Obtained
contestPointObtainedUrl:{
    "link":BaseURL + "api/quizzes/user/points-obtained/"
},
// Contest Point Obtained
contestLeaderBoardUrl:{
    "link":BaseURL + "api/quizzes/user/leaderboard/"
},
// Interview Course Details
interViewCourseDetailsUrl:{
    "link":BaseURL + "api/courses/user/interview_course/"
},
// Interview Course Details
interViewCourseSectionDetailsUrl:{
    "link":BaseURL + "api/courses/user/interview_section/"
},
// User Quiz History
userQuizHistoriesUrl:{
    "link":BaseURL + "api/quizzes/user/user-quiz-history/"
},
// User Contest Feedback Url
userContestFeedbackUrl:{
    "link":BaseURL + "api/account/user/feedback/"
},
// School Leaderboard Url
schoolLeaderBoardUrl:{
    "link": BaseURL + "api/quizzes/user/school-leaderboard/"
},
// School Leaderboard Url
schoolSuggestionUrl:{
    "link": BaseURL + "api/quizzes/user/school_suggestion/"
},
// School Leaderboard Url
publicLeaderboardUrl:{
    "link": BaseURL + "api/quizzes/public/leaderboard/"
},
// Mobile Number Verify Url
mblVerifyUrl:{
    "link": BaseURL + "api/account/user/mobile-update/"
},
// Mobile Number Add Url
addMblVerifyUrl:{
    "link": BaseURL + "api/account/user/mobile-verify/"
},
ivContestListLink:{
    "link": BaseURL + "api/quizzes/admin/interview-quiz/"
},
pubIvContestInfoLink:{
 "link": BaseURL + "api/quizzes/admin/public-interview-quiz/"
},
pubIvUnitInfo:{
    "link": BaseURL + "api/quizzes/admin/public-interview-unit/"
},
pubIvUnitSubmittedLink:{
    "link": BaseURL + "api/quizzes/admin/public-interview-unit-activated/"
},
pubIvContestSubmitApiList:{
    "link": BaseURL + "api/quizzes/user/public-useranswer/"
},
ivQuizFeedbackSubmitionLink:{
    "link": BaseURL + "api/account/interview-user/feedback/"
}
}
export default root;
